import { render, staticRenderFns } from "./EditFormDialog.vue?vue&type=template&id=4875ed14&scoped=true&"
import script from "./EditFormDialog.vue?vue&type=script&lang=js&"
export * from "./EditFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875ed14",
  null
  
)

export default component.exports